module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJBAMAAAASvxsjAAAAIVBMVEX////0imX+8Oz6zLv84tj96eL6xbL4tp/3r5X1kW/5valHmZ2mAAAAMUlEQVQI12NgYBJlAAIWESChYSxsocAQLigorsDAoCkJJBgSFyYAlQgzCwHZDkAIAQBsuwQUpy+P7gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xing.png
// module id = QGyD
// module chunks = 1